var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAlertTriangle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 10.25V10.2575M8 5.75V7.25V5.75Z",
    stroke: "white",
    strokeWidth: 1.125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.7499 13.2504H13.2499C13.4946 13.2487 13.7352 13.1871 13.9507 13.071C14.1662 12.955 14.35 12.788 14.4861 12.5846C14.6222 12.3812 14.7064 12.1475 14.7315 11.9041C14.7566 11.6606 14.7217 11.4148 14.6299 11.1879L9.3049 2.00038C9.17518 1.76593 8.98503 1.5705 8.75421 1.43442C8.5234 1.29833 8.26034 1.22656 7.9924 1.22656C7.72445 1.22656 7.4614 1.29833 7.23058 1.43442C6.99977 1.5705 6.80962 1.76593 6.6799 2.00038L1.3549 11.1879C1.26485 11.4096 1.22915 11.6496 1.25076 11.8879C1.27237 12.1262 1.35068 12.3558 1.47914 12.5577C1.6076 12.7595 1.78248 12.9278 1.98919 13.0483C2.1959 13.1688 2.42844 13.2381 2.6674 13.2504",
    stroke: "white",
    strokeWidth: 1.125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertTriangle);
export default __webpack_public_path__ + "static/media/alert-triangle.647d4d5f.svg";
export { ForwardRef as ReactComponent };